import React, { useEffect, useState } from 'react';
import categoriesAPI from '../../API/categoriesAPI';
import Drawer from '../Mobile/Drawer';
import Footer from './Footers/Footer';
import Header from './Header';

type PropsType = {
  children: React.ReactNode;
  childrenClasses?: string;
};

export default function Layout({ children, childrenClasses }: PropsType) {
  const [drawer, setDrawer] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    categoriesAPI.getEvents().then((response) => {
      setEvents(response.data);
    });
  }, []);

  return (
    <div className='flex min-h-screen w-full flex-col overflow-x-hidden bg-canvas'>
      <Drawer events={events} open={drawer} action={() => setDrawer(!drawer)} />
      <Header events={events} drawerAction={() => setDrawer(!drawer)} />
      <main className={`flex-1 ${childrenClasses ?? ''}`}>{children}</main>
      <Footer />
    </div>
  );
}
